import request from '../request/http';


/**
 *文章列表
 */
 export function articleList(data) {
  return request({
    url: '/yunxue_co_api/msg/getArticleList?ArtColumn=yunxue&pageIndex=1&pageSize=10&type=',
    method: 'get',
    isJson: true
  })
}


/**
 *文章内容
 */
 export function articleDetail(data) {
  return request({
    url: '/yunxue_co_api/msg/getCompanyForumInfo?ID='+data.id,
    method: 'get',
    isJson: true
  })
}

/**
 *报名
 */
 export function addAdvisePost(data) {
  return request({
    url: '/yunxue_co_api/systemConfig/addAdvise?adviceContent=12412412&adviceType=5&memberId=0',
    method: 'post',
    data: data
  })
}

// //单页：http://pc.shihua.com/prod-api/api/info/sign?typeid=10
// /**
//  *通知内容
//  */
//  export function subMessage(data) {
//   return request({
//     url: '/prod-api/api/info/message',
//     method: 'post',
//     data: data
//   })
// }


// /**
//  *通知内容
//  */
//  export function getCertificate(data) {
//   return request({
//     url: '/api/certificate/getCertificateByNo?numberNo='+data.numberNo,
//     method: 'get',
//     isJson: true
//   })
// }


// //生态课程八个
// export function getstList(data) {
//   return request({
//     url: '/api/product/list?ids=1011,506,505,580,320,277,327,538',
//     method: 'post',
//     data: data
//   })
// }
// //课程详情
// export function getstDetail(data) {
//   return request({
//     url: '/api/product/index?id='+data.id,
//     method: 'get',
//     isJson: true
//   })
// }


// //报名通道
// export function signup(data) {
//   return request({
//     url: '/prod-api/api/info/signup',
//     method: 'post',
//     data: data
//   })
// }


// /**
//  *明星讲师
//  */
//  export function teacherList() {
//   return request({
//     url: '/prod-api/api/info/teacher/list',
//     method: 'get',
//     isJson: true
//   })
// }


// /**
//  *畅销作品列表
//  */
//  export function bookList(data) {
//   return request({
//     url: '/prod-api/api/info/book/list',
//     method: 'get',
//     isJson: true
//   })
// }


// WEBPACK FOOTER //
// ./src/api/api.js